// 接口
const DEFAULT_API_ORIGIN = "https://hlhl.mviqur.vip/";

// 生产环境域名兑接口
function getProdApiOrigin() {
    console.log("typeof window ==='undefined'" + typeof window === "undefined");
    console.log("!window.location" + !window.location);
    console.log("!window.location.origin" + !window.location.origin);
    if (typeof window === "undefined" || !window.location || !window.location.origin) {
        console.log('进入return DEFAULT_API_ORIGIN;');
        
        return DEFAULT_API_ORIGIN;
    }
    console.log('未进入');
    
    // 生产环境：将 www 子域替换为 api 子域作为接口域名
    return window.location.origin.replace(/\/\/www\./i, "//api.");
}

// 判断是否包含本地运行 用于打包环境
// function isLocalhost() {
//     const h = window.location.hostname;
    
//     if (h === "localhost" || h === "127.0.0.1") return true;
//     if (/^127(?:\.\d{1,3}){3}$/.test(h)) return true;
//     return false;
// }

// 1. development（开发模式） 
// 2. production（生产模式）
// 3. test（测试模式
console.log(process.env.NODE_ENV === "production");


const API_ORIGIN = process.env.NODE_ENV === "production" ? getProdApiOrigin() : DEFAULT_API_ORIGIN;
console.log(API_ORIGIN);

let SERVERTAPI = `${API_ORIGIN.replace(/\/+$/, "")}/`;

if (typeof window !== "undefined") {
    localStorage.setItem("baseUrl", SERVERTAPI);
}

console.log('Type:' + process.env.NODE_ENV);
// console.log('ConfigApi:' + SERVERTAPI);

export {
    SERVERTAPI,
}
